import * as Yup from 'yup'

export const enderecoSchema = (isEdicao: boolean) =>
  Yup.object().shape({
    // O backend não permite trocar o tipo de um endereço já cadastrado (`EnderecoDtoUpdate` não
    // tem o campo), por isso na edição o select vai desabilitado e a validação não o exige.
    tipo: Yup.object()
      .nullable()
      .when([], {
        is: () => !isEdicao,
        then: (schema) => schema.required('O tipo de endereço é obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),
    nome: Yup.string().trim().max(100, 'Máximo de 100 caracteres'),
    cep: Yup.string()
      .matches(/^\d{2}\.\d{3}-\d{3}$/, 'Formato deve ser 00.000-000')
      .required('O campo CEP é obrigatório'),
    logradouro: Yup.string()
      .trim()
      .min(5, 'Mínimo de 5 caracteres')
      .max(50, 'Máximo de 50 caracteres')
      .required('O campo logradouro é obrigatório'),
    numero: Yup.string().trim().required('O campo número é obrigatório'),
    complemento: Yup.string().trim().max(100, 'Máximo de 100 caracteres'),
    bairro: Yup.string()
      .trim()
      .min(3, 'Mínimo de 3 caracteres')
      .max(50, 'Máximo de 50 caracteres')
      .required('O campo bairro é obrigatório'),
    cidade: Yup.string()
      .trim()
      .min(3, 'Mínimo de 3 caracteres')
      .max(50, 'Máximo de 50 caracteres')
      .required('O campo cidade é obrigatório'),
    uf: Yup.object().nullable().required('O campo estado é obrigatório'),
  })
